import { merchantComputed } from '@store/helpers'
import { categoryOptions, storeOptions } from "@utils/ipetbooking-options";
import { serviceMenuList, termsMenuList } from "@src/config/menu";

export default {
  data() {
    return {
      termsMenuList: Object.freeze(termsMenuList()),
      serviceMenuList: Object.freeze(serviceMenuList()),
      storeOpenOptions: Object.freeze(storeOptions({
        type: 'open'
      })),
      categoryAllOptions: Object.freeze(categoryOptions())
    }
  },
  computed: {
    ...merchantComputed,
  },
  methods: {
    openDialogLine() {
      if(this.$globalIsMobileDevice && this.currentMerchant.lineFriendUrl) {
        window.open(this.currentMerchant.lineFriendUrl)
      } else {
        this.$globalDialog('DialogLine', {
          lineId: this.currentMerchant.lineId,
          lineFriendUrl: this.currentMerchant.lineFriendUrl
        });
      }
    },
  }
}
